import { useContext } from "react";
import { EnvContext } from "../contexts/EnvContext";
export var useEnvContext = function () {
    var ctxConsumer = useContext(EnvContext);
    return ctxConsumer;
};
//# sourceMappingURL=useEnvContext.js.map